import React from "react";
import {GridCell, GridTable} from "../../Components/Grid";
import {LibraryItemCopyDisplay} from "./LibraryItemCopyDisplay";
import {LibraryItemCopyEdit} from "./LibraryItemCopyEdit";

interface LibraryItemCopyProps {
    editCopyId: string;
    handleBarcode: (copyId: string) => void;
    handleDone: (data: Record<string, unknown>) => void;
    isEditing: boolean;
    itemForm: Record<string, any>;
    setEditCopyId: (id: string) => void;
}

export const LibraryItemCopy = ({
                                    editCopyId,
                                    handleBarcode,
                                    handleDone,
                                    isEditing,
                                    itemForm,
                                    setEditCopyId,
                                }: LibraryItemCopyProps) => {

    const handleCancel = () => setEditCopyId("");
    const hasCopies = itemForm?.copies?.value?.length > 0;

    return <>
        <GridCell>
            <GridTable className={`searchResults`}>
                <thead>
                <tr>
                    <th className={`small-cell`}>Copy&nbsp;#</th>
                    <th>Access Number</th>
                    <th>Location</th>
                    <th>Status</th>
                    <th className={`action-cell`}>Actions</th>
                </tr>
                </thead>
                <tbody>
                {
                    hasCopies &&
                    itemForm?.copies?.value?.map((copy: Record<string, any>) => {
                        const copyId = copy.copyId;

                        return editCopyId === copyId ?
                            <LibraryItemCopyEdit
                                copy={copy}
                                handleCancel={handleCancel}
                                handleDone={handleDone}
                                key={copyId}
                            /> :
                            <LibraryItemCopyDisplay
                                copy={copy}
                                handleBarcode={handleBarcode}
                                handleEdit={isEditing ? null : setEditCopyId}
                                key={copyId}
                            />
                    })
                }
                {
                    !hasCopies &&
                    <tr>
                        <td colSpan={5} className={`text-center`}>No inventory yet.</td>
                    </tr>
                }
                </tbody>
            </GridTable>
        </GridCell>
    </>;
};
